import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import LazyLoader from "../../../../components/LazyLoader";
import CreateRevenueSettingsForm from "./createRevenueSettingsForm";
import EditRevenueSettingsForm from "./editRevenueSettingsForm";
import { showARevenueSettings } from "../../../../redux/revenueSettings/revenueSettingsActions";

/**
 * Revenue settings for a single business or shipper: edit if they exist, else create.
 * @param {"business" | "shipper"} type
 */
export default function RevenueSettingsPage({ type = "business" }) {
  const dispatch = useDispatch();
  const { id } = useParams();

  // kept locally (not in redux) so another business/shipper's settings never show while loading
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setSettings(null);
    setIsLoading(true);

    const fetchSettings = async () => {
      const response = await dispatch(showARevenueSettings(id, type));
      if (ignore) return;
      setSettings(response?.data?.id ? response.data : null);
      setIsLoading(false);
    };

    if (id) {
      fetchSettings();
    }
    return () => {
      ignore = true;
    };
  }, [dispatch, id, type]);

  return (
    <div data-test={`${type}-split-page`}>
      {isLoading ? (
        <LazyLoader />
      ) : settings ? (
        <EditRevenueSettingsForm
          key={settings.id}
          ownerId={id}
          type={type}
          settings={settings}
        />
      ) : (
        <CreateRevenueSettingsForm key={id} ownerId={id} type={type} />
      )}
    </div>
  );
}
